export const CONTACT = {
  phone: "+48 501 254 893",
  phoneHref: "tel:+48501254893",
  telegram: "https://t.me/skystart",
  whatsapp: "https://wa.me/48501254893",
  // Uzupełnij rzeczywiste profile przed publikacją — nie zgadujemy adresów social.
  facebook: "",
  instagram: "",
  logo: "/logo.webp",
};

export const COMPANY = {
  name: "Voxia sp. z o.o.",
  nip: "5214140830",
  regon: "543241230",
  krs: "0001204936",
  address: "ul. Władysława Pytlasińskiego 16/13",
  city: "00-777 Warszawa",
};

export const MEDIA = {
  heroVideo: "https://assets.mixkit.co/videos/preview/mixkit-aerial-view-of-a-forest-1565-large.mp4",
  heroPoster: "https://static.prod-images.emergentagent.com/jobs/c9828dc1-1b25-4c99-9ddd-5d26413916c3/images/c3a812fbd7ea46b4cbf93a765f20c493f7d4cf94980f56b8ee83c1b4adebb12b.png",
  offer: "https://images.unsplash.com/photo-1548680711-a5ca90c250b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  about: "https://images.unsplash.com/photo-1482169704817-5b66aafa1a01?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Language-independent fleet data (models + images). Text comes from i18n.
export const FLEET = [
  {
    id: "rec",
    models: "DJI Neo 2 · DJI Neo",
    image: "https://static.prod-images.emergentagent.com/jobs/c9828dc1-1b25-4c99-9ddd-5d26413916c3/images/f1d42adbcd931971da4304de7d533b814bae54cf8fd53570c4685972f780a7ae.png",
  },
  {
    id: "photo",
    models: "DJI Mini 3 Pro",
    image: "https://static.prod-images.emergentagent.com/jobs/c9828dc1-1b25-4c99-9ddd-5d26413916c3/images/af5b66c71cbcf1f0aefbc758cc8dc63b442d3b4943d5a4ef69086785349e6fe4.png",
  },
  {
    id: "fpv",
    models: "DJI Neo / Neo 2 → DJI Avata 2",
    image: "https://images.unsplash.com/photo-1690646728656-21dd115f4414?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];
